export enum DeletedMessageDisplay {
    Default = 'Default',
    ShowAsNormal = 'ShowAsNormal',
    Hide = 'Hide',
}